import angular from 'angular';
import Compile from './compile.js';

const utils = angular.module('utils', []);

utils.directive('compile', Compile);

export {utils};



// WEBPACK FOOTER //
// ./app/components/common/utils/utils.js